<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    height="24px"
    viewBox="0 0 24 24">
    <g transform="translate(0, 0)">
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="6"
        y1="12"
        x2="3"
        y2="12"
        stroke-linejoin="miter" />
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="6"
        y1="17"
        x2="5"
        y2="17"
        stroke-linejoin="miter" />
      <polyline
        data-cap="butt"
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
        points="17.829,18 23,18 23,12 19,10
18,6 10,6 10,18 12.171,18 "
        stroke-linejoin="miter"
        stroke-linecap="butt" />
      <line
        data-color="color-2"
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        x1="1"
        y1="7"
        x2="6"
        y2="7"
        stroke-linejoin="miter" />
      <polyline
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        points="1,2 10,2 10,6 "
        stroke-linejoin="miter" />
      <circle
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        cx="15"
        cy="19"
        r="3"
        stroke-linejoin="miter" />
      <polyline
        fill="none"
        stroke-width="2"
        stroke-linecap="square"
        stroke-miterlimit="10"
        points="14,9 14,11 16,11
"
        stroke-linejoin="miter" />
    </g>
  </svg>
</template>
